import { Icon, tk, Typography, UnavailableContentDialog } from '@sunwebgroup/ui-components';
import { useIntl } from 'react-intl';
import { styled, css } from 'styled-components';

type Breakpoint =
  | 'breakpoint_tablet'
  | 'breakpoint_desktop_sm'
  | 'breakpoint_desktop_md'
  | 'breakpoint_desktop_lg'
  | 'breakpoint_desktop_xl';

const Table = styled.table`
  ${Typography.modVariant('label-thin')}
  width: 100%;
  border-collapse: collapse;
`;

const sharedCellStyles = css<{ $hideOn?: Breakpoint; $size?: 'lg' }>`
  padding: ${tk('spacing_md')} 0;
  width: ${({ $size }) => ($size === 'lg' ? '240px' : '140px')};

  &:first-child {
    flex-grow: 1;
  }

  &:last-child {
    text-align: right;
    width: 80px;
  }

  @media (max-width: ${tk('breakpoint_desktop_sm')}) {
    padding: ${tk('spacing_sm')} 0;
  }

  ${({ $hideOn }) =>
    $hideOn &&
    css`
      @media (max-width: ${tk($hideOn)}) {
        display: none;
      }
    `}
`;

const TableHead = styled.th<{ $hideOn?: Breakpoint; $size?: 'lg' }>`
  color: ${tk('color_semantic_text_subdued')};
  text-align: left;
  ${sharedCellStyles}
`;

const TableCell = styled.td<{ $hideOn?: Breakpoint; $size?: 'lg' }>`
  ${sharedCellStyles}
  align-content: center;

  &:first-child {
    font-weight: ${tk('font_weight_semibold')};
  }
`;

const TableRow = styled.tr`
  display: flex;
  padding: 0 ${tk('spacing_md')};
  gap: ${tk('spacing_md')};
  border-bottom: 2px solid ${tk('color_semantic_border')};

  @media (max-width: ${tk('breakpoint_desktop_sm')}) {
    padding: 0 ${tk('spacing_sm')};
    gap: ${tk('spacing_sm')};
  }
`;

const Subtitle = styled(Typography)`
  color: ${tk('color_semantic_text_subdued')};
`;

const TableCellWithSubtitle = styled(TableCell)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-wrap: break-word;
`;

const TableBody = styled.tbody`
  tr:hover {
    background-color: ${tk('color_semantic_bg_subdued_hover')};
  }
`;

const EmptyTableMessage = () => {
  const intl = useIntl();

  const StyledUnavailableContentDialog = styled(UnavailableContentDialog)`
    margin-top: ${tk('spacing_4xl')};
  `;

  return (
    <StyledUnavailableContentDialog
      icon={<Icon glyph="IconFaceSad" size="lg" />}
      title={intl.formatMessage({ id: 'groups_responsible__no_data_title' })}
      message={intl.formatMessage({ id: 'groups_responsible__no_data_description' })}
    />
  );
};

export { Table, TableHead, TableCell, TableRow, Subtitle, TableCellWithSubtitle, TableBody, EmptyTableMessage };
